import '@px/helper/pollyfill/Array';
import '@px/helper/pollyfill/EventTarget';
import '@px/helper/pollyfill/Map';
import '@px/helper/pollyfill/rxjs';
import {main} from './main';

declare const WORKER_URL: string;

main(() => new Worker(WORKER_URL)).then();

// 替 tingyun 兜底，清理错误配置，运行几个月级别时间后可以删除
if ((localStorage.getItem('TINGYUN_STORAGE') || '').includes('apm2')) {
  console.log('deleted')
  localStorage.removeItem('TINGYUN_STORAGE');
}
